import React, { useContext } from "react";
import { Snack, Snackbar } from "@nike/eds";
import SnackbarContext from "../../providers/snackbar-context";

function ApplicationSnackbar(props) {
    const snackbarCtx = useContext(SnackbarContext);

    type Status =  "info" | "success" | "warning" | "error" | "neutral" | "danger";
    let status: Status = "error";
    if (snackbarCtx.status === "info") {
        status = "info";
    } else if (snackbarCtx.status === "success") {
        status = "success";
    } else if (snackbarCtx.status === "warning") {
        status = "warning";
    } else if (snackbarCtx.status === "error") {
        status = "error";
    } else if (snackbarCtx.status === "neutral") {
        status = "neutral";
    } else if (snackbarCtx.status === "danger") {
        status = "danger";
    }

    return (
        <Snackbar>
            <Snack id={"1"} hideDismiss={true} status={status} onDismiss={snackbarCtx.onClose}>
              { snackbarCtx.msg }
            </Snack>
        </Snackbar>
    )
};

export default ApplicationSnackbar;